import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Section } from 'styles';
import { SubTitle, TimeTable } from 'components';
import { useSearchParams } from 'react-router-dom';
import { DISPLAY_VALUE_TYPES, DISPLAY_TIME_TYPES } from 'data/constants';
import houseSensorService from 'services/house/house-sensor-service';
import commonSensorService from 'services/common-sensor-service';

export function HouseSensor(props) {
  const [searchParams, setSearchParams] = useSearchParams();
  
  const [sensor, setSensor] = useState({});
  const [sensorUnit, setSensorUnit] = useState(null);
  const [sensorData, setSensorData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [chartInputData, setChartInputData] = useState(null);
  const [tableInputData, setTableInputData] = useState(null);
  const [chartOverrideOptions, setChartOverrideOptions] = useState(null);
  const [hourlyList, setHourlyList] = useState([]);

  const [filters, setFilters] = useState({
    date: moment(new Date()).format('YYYY.MM.DD'),
    searchEndDate: moment(new Date()).format('YYYY.MM.DD'),
    type: DISPLAY_VALUE_TYPES[0].val,
    timeType: DISPLAY_TIME_TYPES[0].val,
    apiCallIndex: 0
  });

  const onChange = (name, val) => {
    setFilters({ ...filters, [name]: val });
  };

  const updateChartInputData = (data, chartDisplayType, sensorType) => {
    const newChartInputData = commonSensorService.processChartInputData(data, chartDisplayType, 
      filters.date === filters.searchEndDate ? 'HH' : 'YYYY-MM-DD HH:mm:ss');

    let legendPostfix = '';

    if (sensorType) {
      if (sensorType.toUpperCase().startsWith('TEMP_')) {
        legendPostfix = ' 온도';
      } else if (sensorType.toUpperCase().startsWith('RH_')) {
        legendPostfix = ' 습도';
      } else if (sensorType.toUpperCase().startsWith('CO2_')) {
        legendPostfix = ' 이산화탄소';
      } else if (sensorType.toUpperCase().startsWith('SOILTEMP_')) {
        legendPostfix = ' 지온';
      } else if (sensorType.toUpperCase().startsWith('SOILRH_')) {
        legendPostfix = ' 지습';
      }
    }

    if (newChartInputData && newChartInputData.data1) {
      newChartInputData.data1.name += legendPostfix
    }

    if (newChartInputData && newChartInputData.data2) {
      newChartInputData.data2.name += legendPostfix
    }

    if (newChartInputData && newChartInputData.data3) {
      newChartInputData.data3.name += legendPostfix
    }

    setChartInputData(newChartInputData);
  }

  const updateTableInputData = (data) => {
    const processedData = commonSensorService.processTableInputData(data);

    setTableInputData(processedData);
  }

  const updateChartOverrideOptions = (sensorType) => {
    const overrideOptions = commonSensorService.getChartOverrideOptions(sensorType);

    setChartOverrideOptions(overrideOptions);
  }

  useEffect(() => {
    const fetchData = async () => {
      const startTime = moment(filters.date).format('YYYYMMDD000000');
      const endTime = moment(filters.searchEndDate).format('YYYYMMDD235959');

      // 날짜 차이를 계산
      const monthsDiff = moment(filters.searchEndDate).diff(moment(filters.date), 'months');
      
      // 6개월 이상이면 alert 창 표시
      if (monthsDiff > 6) {
        alert('6개월 이상은 조회 할 수 없습니다. \n값을 다시 설정해 주세요');
        setLoading(false);
        return; // 데이터 요청을 중단
      }

      let data = [];
      let tempHourlyList = Array.from({ length: 24 }, (_, i) => i);
      try {
        data = await houseSensorService.getHouseSensorDetail(searchParams.get('type'), startTime, endTime);

        const daysDiff = moment(filters.searchEndDate).diff(moment(filters.date), 'days');
        
        let hourlyModulo = 1;

        if (daysDiff >= 90) {
          hourlyModulo = 12;
          tempHourlyList = [0, 12];
        } else if (daysDiff >= 30) {
          hourlyModulo = 6;
          tempHourlyList = [0, 6, 12, 18];
        } else if (daysDiff >= 14) {
          hourlyModulo = 2;
          tempHourlyList = Array.from({ length: 12 }, (_, i) => i * 2);
        }

        data = data.filter((d) => moment(d.timestamp).hours() % hourlyModulo === 0);

        // data.forEach((d) => {
        //   d.sensor_value = Math.random()*1000;
        // })
      } catch (e) {
        console.error(e);
      }

      if (data && data.length > 0) {
        setSensor(data[0]);
        setSensorUnit(commonSensorService.getSensorUnit(data[0].sensor_type))
        setSensorData(data);
        setHourlyList(tempHourlyList);
      } else {
        setSensor({});
        setSensorUnit(null);
        setSensorData([]);
        setHourlyList([]);
      }

      setLoading(false)
    }

    setLoading(true);
    fetchData();
  }, [searchParams, filters.apiCallIndex]);

  useEffect(() => {
    updateChartOverrideOptions(sensor.sensor_type);
    updateChartInputData(sensorData, filters.type, sensor.sensor_type)
    updateTableInputData(sensorData);
  }, [sensorData, filters.type])

  return (
    <Section>
      <SubTitle title="센서 데이터" sub="Sensors" desc={sensor.sensor_name} />
      <TimeTable filters={filters} onChange={onChange} switchList={DISPLAY_VALUE_TYPES} timeList={DISPLAY_TIME_TYPES} chartInputData={chartInputData} tableInputData={tableInputData} loading={loading} unit={sensorUnit} chartOverrideOptions={chartOverrideOptions} 
      onClickSearchDate={() => {
        onChange('apiCallIndex', filters.apiCallIndex + 1)
      }}
      dateStartEndSearch
      hourlyList={hourlyList} />
    </Section>
  );
}
